// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"e2ffa26c","483":"a0a98f1a","554":"7a3ca377","622":"2b009376","627":"e3cff7fc","686":"fcadfdbd","925":"c5bd2bfc","976":"6c1b47e5","986":"f29973ed"}[chunkId] + ".chunk.js";
};